module.exports = __webpack_public_path__ + "img/36.9c68a5bc.png";